import { Container } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import React from 'react';
import HVACConsultationIneligible from '../../../../components/pge-plus/consultation/ineligible';

const HVACConsultationIneligiblePage: React.FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  return (
    <>
      <Container>
        <HVACConsultationIneligible />
      </Container>
    </>
  );
};

export default HVACConsultationIneligiblePage;
